import { v4 as uuid } from "uuid";
import { z } from "zod";
export var PurchaserType;
(function (PurchaserType) {
    PurchaserType["Direct"] = "purchaser-type_direct";
    PurchaserType["Indirect"] = "purchaser-type_indirect";
})(PurchaserType || (PurchaserType = {}));
export var SocialSpendEntityType;
(function (SocialSpendEntityType) {
    //Victoria
    SocialSpendEntityType["None"] = "social-spend-entity-type_none";
    SocialSpendEntityType["SocialEnterprise"] = "social-spend-entity-type_social-enterprise";
    SocialSpendEntityType["DisabilityEnterprise"] = "social-spend-entity-type_disability-enterprise";
    SocialSpendEntityType["IndigenousEnterprise"] = "social-spend-entity-type_indigenous-enterprise";
    SocialSpendEntityType["RegionSpecific"] = "social-spend-entity-type_region-specific";
    SocialSpendEntityType["SmallMediumEnterprise"] = "social-spend-entity-type_small-medium-enterprise";
})(SocialSpendEntityType || (SocialSpendEntityType = {}));
export var SocialSpendCertificate;
(function (SocialSpendCertificate) {
    SocialSpendCertificate["AustralianCharitiesAndNotForProfitsCommision"] = "social-procurement-certificate_australian-charities-and-not-for-profits-commision";
    SocialSpendCertificate["AustralianNetworkOnDisability"] = "social-procurement-certificate_australian-network-on-disability";
    SocialSpendCertificate["DepartmentOfEducation"] = "social-procurement-certificate_department-of-education";
    SocialSpendCertificate["Kinaway"] = "social-procurement-certificate_kinaway";
    SocialSpendCertificate["SocialTraders"] = "social-procurement-certificate_social-traders";
    SocialSpendCertificate["SupplyNationCertified"] = "social-procurement-certificate_supply-nation-certified";
    SocialSpendCertificate["SupplyNationRegistered"] = "social-procurement-certificate_supply-nation-registered";
    SocialSpendCertificate["None"] = "social-procurement-certificate_none";
    SocialSpendCertificate["QueenslandIndigenousBusinessNetwork"] = "social-procurement-certificate_queensland-indigenous-business-network";
    SocialSpendCertificate["PeopleAndPlanetFirst"] = "social-procurement-certificate_people-and-planet-first";
    SocialSpendCertificate["BuyQLDVerified"] = "social-procurement-certificate_buy-qld-verified";
    SocialSpendCertificate["AboriginalBusinessDirectoryWA"] = "social-procurement-certificate_aboriginal-business-directory-wa";
})(SocialSpendCertificate || (SocialSpendCertificate = {}));
export var SocialSpendServiceCategory;
(function (SocialSpendServiceCategory) {
    SocialSpendServiceCategory["AdvertisingAndMedia"] = "social-procurement-service-category_advertising-and-media";
    SocialSpendServiceCategory["ArchitecturePlanningAndDesign"] = "social-procurement-service-category_architecture-planning-and-design";
    SocialSpendServiceCategory["BuildingProductsAndMaterials"] = "social-procurement-service-category_building-products-and-materials";
    SocialSpendServiceCategory["BuildingTradeRepairsAndMaintenance"] = "social-procurement-service-category_building-trade-repairs-and-maintenance";
    SocialSpendServiceCategory["BusinessAndAdministrativeServices"] = "social-procurement-service-category_business-and-administrative-services";
    SocialSpendServiceCategory["CateringAndHospitality"] = "social-procurement-service-category_catering-and-hospitality";
    SocialSpendServiceCategory["CivilConstruction"] = "social-procurement-service-category_civil-construction";
    SocialSpendServiceCategory["CleaningServicesAndEquipmentAndSupplies"] = "social-procurement-service-category_cleaning-services-and-equipment-and-supplies";
    SocialSpendServiceCategory["ClothingAndSafetyEquipment"] = "social-procurement-service-category_clothing-and-safety-equipment";
    SocialSpendServiceCategory["CommunicationsPromotionalMaterials"] = "social-procurement-service-category_communications-promotional-materials";
    SocialSpendServiceCategory["ConstructionPlantWetAndDryAndToolHire"] = "social-procurement-service-category_construction-plant-wet-and-dry-and-tool-hire";
    SocialSpendServiceCategory["CraneHire"] = "social-procurement-service-category_crane-hire";
    SocialSpendServiceCategory["CulturalHeritageManagement"] = "social-procurement-service-category_cultural-heritage-management";
    SocialSpendServiceCategory["ElectricalContractors"] = "social-procurement-service-category_electrical-contractors";
    SocialSpendServiceCategory["EmploymentDirect"] = "social-procurement-service-category_employment-direct";
    SocialSpendServiceCategory["EmploymentLabourHire"] = "social-procurement-service-category_employment-labour-hire";
    SocialSpendServiceCategory["EngineerResearchTechServices"] = "social-procurement-service-category_engineer-research-tech-services";
    SocialSpendServiceCategory["EventsVenueHire"] = "social-procurement-service-category_events-venue-hire";
    SocialSpendServiceCategory["FinancialAndInsuranceServices"] = "social-procurement-service-category_financial-and-insurance-services";
    SocialSpendServiceCategory["FleetHireAndCleaning"] = "social-procurement-service-category_fleet-hire-and-cleaning";
    SocialSpendServiceCategory["FleetServicingAndaccessories"] = "social-procurement-service-category_fleet-servicing-and-accessories";
    SocialSpendServiceCategory["FoodAndBeverageProducts"] = "social-procurement-service-category_food-and-beverage-products";
    SocialSpendServiceCategory["FurnitureAndFurnishings"] = "social-procurement-service-category_furniture-and-furnishings";
    SocialSpendServiceCategory["GiftsOrrewards"] = "social-procurement-service-category_gifts-or-rewards";
    SocialSpendServiceCategory["HealthcareServices"] = "social-procurement-service-category_healthcare-services";
    SocialSpendServiceCategory["HorticultureAndarboriculture"] = "social-procurement-service-category_horticulture-and-arboriculture";
    SocialSpendServiceCategory["HumanResourceServicesAndrecruitment"] = "social-procurement-service-category_human-resource-services-and-recruitment";
    SocialSpendServiceCategory["IndustrialProductionAndmanufacture"] = "social-procurement-service-category_industrial-production-and-manufacture";
    SocialSpendServiceCategory["ITAndTelecomms"] = "social-procurement-service-category_it-and-telecomms";
    SocialSpendServiceCategory["LandscapingAndArchitecturalSupplyAndConstruction"] = "social-procurement-service-category_landscaping-and-architectural-supply-and-construction";
    SocialSpendServiceCategory["LegalServices"] = "social-procurement-service-category_legal-services";
    SocialSpendServiceCategory["LibraryServices"] = "social-procurement-service-category_library-services";
    SocialSpendServiceCategory["MarketingAndCommunications"] = "social-procurement-service-category_marketing-and-communications";
    SocialSpendServiceCategory["MechanicalServices"] = "social-procurement-service-category_mechanical-services";
    SocialSpendServiceCategory["MerchandiseAndPersonalProducts"] = "social-procurement-service-category_merchandise-and-personal-products";
    SocialSpendServiceCategory["MiningOilAndGas"] = "social-procurement-service-category_mining-oil-and-gas";
    SocialSpendServiceCategory["MusicAndGamesAndToysAndArtsAndCraftsAndEducational"] = "social-procurement-service-category_music-and-games-and-toys-and-arts-and-crafts-and-educational";
    SocialSpendServiceCategory["OfficeConsumables"] = "social-procurement-service-category_office-consumables";
    SocialSpendServiceCategory["OfficeSuppliesAndservices"] = "social-procurement-service-category_office-supplies-and-services";
    SocialSpendServiceCategory["ParkingAndTrafficServicesAndEquipment"] = "social-procurement-service-category_parking-and-traffic-services-and-equipment";
    SocialSpendServiceCategory["PavementConstruction"] = "social-procurement-service-category_pavement-construction";
    SocialSpendServiceCategory["PersonalAndDomesticServices"] = "social-procurement-service-category_personal-and-domestic-services";
    SocialSpendServiceCategory["PersonalProtectiveEquipmentPPE"] = "social-procurement-service-category_personal-protective-equipment-ppe";
    SocialSpendServiceCategory["PrecastConcrete"] = "social-procurement-service-category_precast-concrete";
    SocialSpendServiceCategory["PrintingAndDistributionServices"] = "social-procurement-service-category_printing-and-distribution-services";
    SocialSpendServiceCategory["ProfessionalConsultancyServices"] = "social-procurement-service-category_professional-consultancy-services";
    SocialSpendServiceCategory["RealEstateAndpropertyServices"] = "social-procurement-service-category_real-estate-and-property-services";
    SocialSpendServiceCategory["RenewableEnergy"] = "social-procurement-service-category_renewable-energy";
    SocialSpendServiceCategory["SafetyBarriersAndBollards"] = "social-procurement-service-category_safety-barriers-and-bollards";
    SocialSpendServiceCategory["ScaffoldingAndaccess"] = "social-procurement-service-category_scaffolding-and-access";
    SocialSpendServiceCategory["SecurityServicesAndEquipment"] = "social-procurement-service-category_security-services-and-equipment";
    SocialSpendServiceCategory["SignsAndBarriers"] = "social-procurement-service-category_signs-and-barriers";
    SocialSpendServiceCategory["SignsAndpavementMarkings"] = "social-procurement-service-category_signs-and-pavement-markings";
    SocialSpendServiceCategory["SiteFacilities"] = "social-procurement-service-category_site-facilities";
    SocialSpendServiceCategory["SportAndRecEquipmentAndServices"] = "social-procurement-service-category_sport-and-rec-equipment-and-services";
    SocialSpendServiceCategory["StormwaterAndsubsurfaceDrainageSupplyOrinstallation"] = "social-procurement-service-category_stormwater-and-subsurface-drainage-supply-or-installation";
    SocialSpendServiceCategory["StructuralSteelFabrication"] = "social-procurement-service-category_structural-steel-fabrication";
    SocialSpendServiceCategory["Surveying"] = "social-procurement-service-category_surveying";
    SocialSpendServiceCategory["TrafficManagement"] = "social-procurement-service-category_traffic-management";
    SocialSpendServiceCategory["TrafficServicesAndEquipment"] = "social-procurement-service-category_traffic-services-and-equipment";
    SocialSpendServiceCategory["TrainingAndEducationServices"] = "social-procurement-service-category_training-and-education-services";
    SocialSpendServiceCategory["TransportFreightAndLogistics"] = "social-procurement-service-category_transport-freight-and-logistics";
    SocialSpendServiceCategory["TravelAndTourism"] = "social-procurement-service-category_travel-and-tourism";
    SocialSpendServiceCategory["UtilityServicesWorks"] = "social-procurement-service-category_utility-services-works";
    SocialSpendServiceCategory["VenueHire"] = "social-procurement-service-category_venue-hire";
    SocialSpendServiceCategory["WasteManagement"] = "social-procurement-service-category_waste-management";
    SocialSpendServiceCategory["WasteManagementAndLandfill"] = "social-procurement-service-category_waste-management-and-landfill";
    SocialSpendServiceCategory["Geesp"] = "social-procurement-service-category_geesp";
    SocialSpendServiceCategory["None"] = "social-procurement-service-category_none";
})(SocialSpendServiceCategory || (SocialSpendServiceCategory = {}));
export const socialSpendReportByDateSchema = z.object({
    report_id: z.string(),
    total_spend: z.number()
});
export const socialSpendSchema = z.object({
    abn: z.string().optional(),
    applied_target_ids: z.array(z.string()),
    certifications: z.array(z.enum(SocialSpendCertificate)),
    contractor_package_id: z.string(),
    created: z.date(),
    /** Set when generated from labour hours; names the Target Definition. */
    derived_from_target_id: z.string().optional(),
    entity_type: z.enum(SocialSpendEntityType).optional(),
    geo_location_lat: z.number().optional(),
    geo_location_long: z.number().optional(),
    invoice_value: z.number(),
    nature_of_expenditure: z.enum(SocialSpendServiceCategory).optional(),
    organisation_name: z.string().optional(),
    project_id: z.string(),
    purchase_type: z.enum(PurchaserType).optional(),
    purchaser_organisation_abn: z.string(),
    purchaser_organisation_name: z.string(),
    registered: z.boolean(),
    report_id: z.string(),
    social_spend_id: z.string(),
    supplier: z.string().optional(),
    supplier_certifications: z.array(z.enum(SocialSpendCertificate)).optional(),
    supplier_country: z.string().optional(),
    supplier_entity_type: z.enum(SocialSpendEntityType).nullable().optional(),
    supplier_post_code: z.string().optional(),
    supplier_state: z.string().optional(),
    transaction_date: z.date().optional(),
    uri: z.string().optional(),
    victorian_post_code: z.string().optional()
});
export const socialSpendTargetModelSchema = z.object({
    social_spend: z.array(socialSpendSchema),
    total_social_spend: z.number()
});
export const monthSocialSpendSumSchema = z.object({
    invoice_value: z.number(),
    report_id: z.string()
});
export const socialSpendAggSchema = z.object({
    target_id: z.string(),
    total_spend_up_to_report_date: z.number()
});
export const socialSpendMonthlyBreakdownAggSchema = z.object({
    /** Distinct supplier ABNs in this breakdown bucket (from `social_spend.abn`). */
    abns: z.array(z.string()).optional(),
    amount_of_spend: z.number(),
    /** Raw certification values from DB (`TEXT[]`); map to labels in the Public API layer. */
    certifications: z.array(z.string()).optional(),
    entity_type: z.enum(SocialSpendEntityType),
    report_id: z.string(),
    supplier: z.string()
});
export const socialSpendAbnAggSchema = z.object({
    abn: z.string(),
    certifications: z.array(z.enum(SocialSpendCertificate)),
    supplier: z.string(),
    total_spend: z.number()
});
export const socialSpendPackageTotalSchema = z.object({
    contractor_package_id: z.string(),
    total_spend: z.number()
});
export const createDefaultSocialSpendEntity = (projectId, contractorPackageId, reportId, userOrganisation) => {
    return {
        abn: "",
        applied_target_ids: [],
        certifications: [],
        contractor_package_id: contractorPackageId,
        created: new Date(),
        entity_type: SocialSpendEntityType.None,
        invoice_value: 0,
        nature_of_expenditure: SocialSpendServiceCategory.None,
        organisation_name: userOrganisation.organisation_name,
        project_id: projectId,
        purchase_type: PurchaserType.Direct,
        purchaser_organisation_abn: userOrganisation.abn,
        purchaser_organisation_name: userOrganisation.organisation_name,
        registered: false,
        report_id: reportId,
        social_spend_id: uuid(),
        supplier: "",
        supplier_country: "AU",
        supplier_post_code: "",
        supplier_state: "VIC",
        transaction_date: new Date(),
        uri: "",
        victorian_post_code: ""
    };
};
